export default __webpack_public_path__ + "static/media/period.d9fc51c0.svg";